<div class="header-container" [class.login]="isLogin">
  <sm-breadcrumbs
    class="spacer"
    [class.flex-grow-1]="!(userFocus)"
    [class.user-focus]="userFocus "
    [class.share-view]="isShareMode"
    [activeWorkspace]="activeWorkspace">
  </sm-breadcrumbs>
  <div class="ml-3 d-flex align-items-center mr-auto" *ngIf="userFocus">
    <sm-show-only-user-work></sm-show-only-user-work>
  </div>

  <div *ngIf="isDashboard && !isLogin" class="logo-full middle"
       [class.make-room-for-slogan]="environment.whiteLabelSlogan">
    <img alt="logo" [src]="environment?.branding?.logo" width="122" height="42">
    <div *ngIf="environment.whiteLabelSlogan" class="slogan">{{environment.whiteLabelSlogan}}</div>
  </div>
  <div *ngIf="isLogin && environment.whiteLabelLogo" class="logo-full">
    <img alt="logo" [src]="environment?.branding?.logo" width="122" height="42">
  </div>
  <div *ngIf="isLogin" class="spacer"></div>

  <div class="right-buttons">
    <sm-common-search #search [class.share-view]="isShareMode"></sm-common-search>

    <a class="d-flex pointer resources-trigger" [matMenuTriggerFor]="resourcesMenu">
      <i class="al-icon al-ico-help-outlined" data-id="help Icon"></i>
    </a>
    <a class="pointer menu-trigger position-relative" data-id="Avatar" [matMenuTriggerFor]="profileMenu">
      <img alt="avatar" class="avatar"  *ngIf="(user | async).avatar; else iconAvatar" [src]="(user | async).avatar">
      <ng-template #iconAvatar>
        <div class="user-icon">
          <i class="al-icon al-ico-account sm-md"></i>
        </div>
      </ng-template>
      <div *ngIf="userNotificationPath || (invitesPending$ | async)?.length" class="user-notification"></div>
    </a>

    <mat-menu #profileMenu="matMenu" class="user-menu">
      <button mat-menu-item [routerLink]="'settings/' + userNotificationPath">
        <span class="al-icon icon sm-md" [class]="userNotificationPath ? 'al-ico-settings-alert' : 'al-ico-settings'">
          <span class="path1" data-id="Settings Button"></span><span class="path2"></span>
        </span>
        Settings
      </button>
      <sm-header-user-menu-actions></sm-header-user-menu-actions>
      <button mat-menu-item (click)="logout()" data-id="Logout">
        <span class="al-ico-logout al-icon icon sm-md"></span>
        Logout
      </button>
    </mat-menu>

    <mat-menu #resourcesMenu="matMenu" class="user-menu">
      <button mat-menu-item (click)="openWelcome($event)">
        <i class="al-icon sm-md al-ico-code-file"></i>ClearML Python Package setup
      </button>
      <button mat-menu-item (click)="navigate('https://www.youtube.com/c/ClearML/featured')">
        <i class="al-icon al-ico-youtube sm-md"></i>ClearML on Youtube
      </button>
      <button mat-menu-item (click)="navigate(environment.docsLink)">
        <i class="al-icon sm-md al-ico-documentation"></i>Online Documentation
      </button>
      <button mat-menu-item (click)="openTip()">
        <i class="al-icon sm-md al-ico-tips"></i>Pro Tips
      </button>
      <ng-container *smCheckPermission="'applications'">
        <button mat-menu-item
                *ngIf="$any(environment)?.appsYouTubeIntroVideoId && $any(environment).appAwarenessMenu !== false"
                (click)="openAppsAwareness($event, $any(environment)?.appsYouTubeIntroVideoId)"
        >
          <i class="al-icon sm-md al-ico-applications"></i>ClearML Apps Introduction
        </button>
      </ng-container>
      <button mat-menu-item (click)="navigate('mailto:support@clear.ml')">
        <i class="al-icon sm-md al-ico-email"></i>Contact Us
      </button>
    </mat-menu>
  </div>
</div>
<ng-content></ng-content>
